import React, { useEffect, useState } from 'react';
import { useTranslate } from '../components/TranslationText';
import { useSelector } from 'react-redux';
import axios from "../axios/axiosUmbraco";
import Loader from '../components/Loader';
import ActionButton from '../components/ActionButton';
import FilterButton from '../components/FilterButton';
import Lightbox from 'react-18-image-lightbox';
import EducationalFilter from '../components/EducationalFilter';
import ComingSoon from '../components/ComingSoon';
import { showFirst12Words, showFirst22Words } from '../helper/showFirstSixWords';
import { translateMonthToArabic } from '../helper/translateDayToArabic';
import CoursesFilter from '../components/CoursesFilter';
import { Link, useNavigate } from 'react-router-dom';
import axiosInstance from '../axios/axios';
import { formatDate } from '../helper/formatDate';
import { formatDateArray } from '../helper/formatDateArray';
import { filterResponsive, pageTitle, rightResponsive, whiteCard } from '../common/cssclasses';

const BaseURL = process.env.REACT_APP_BASE_URL;
const fetch = process.env.REACT_APP_UMBRACO_EDUCATIONAL_PAGE_ID;
const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

export default function CoursesNewPage() {
    const { translate } = useTranslate();
    const { currentLanguage } = useSelector((state) => state.studBookSlice);
    const navigate = useNavigate();
    const token = localStorage.getItem('accessTokenforEAHS') ?? false;
    const isLoggedIn= !!token;

    const [courses, setCourses] = useState([]);
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);



    async function getdata(title = "", startDate = "", endDate = "", isFilter = false) {
        setIsLoading(true);
        const res = await axiosInstance.get(`/courses/getcourses?title=${title}&startDate=${startDate}&endDate=${endDate}`);

        const formattedData = res.data?.result?.map((item) => ({
            id: item?.id,
            title: item?.title ?? '',
            subtitle: item?.subtitle ?? '',
            link: item?.link ?? '',
            image: item?.image ?? '',
            startDate: item?.startDate ?? '',
            dipslayDate: formatDateArray(item?.startDate) ?? '',
            endDate: item?.endDate ?? '',
            isOpenedToRegister: item?.isOpenedToRegister ?? false,
            isCaltureCourse: item?.isCaltureCourse ?? false,
            termsList: JSON.stringify(item?.termsList) ?? '',

        }));



        setCourses(formattedData);
        if (!isFilter) {
            setTotal(res.data?.result?.length ?? 0);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        getdata();
    }, [currentLanguage]);

    const handleFilter = (filters) => {
        getdata(filters?.coursTitle, filters?.DateFrom ?? '', filters?.DateTo ?? '', true);
    };

    return (
        <>
            {isLoading && <Loader />}
            {total === 0 && !isLoading && <ComingSoon />}
            {total > 0 && (
                <>
                    <div className="row rtl ">
                        <h2 className={pageTitle}>
                            {translate('web.courses', 'Courses')}
                        </h2>
                    </div>
                    <div className="row ">
                        {windowWidth <= 970 && (
                            <div className="col-md-4 col-sm-6 col-6 text-center d-flex justify-content-center mb-3 mx-auto">
                                <FilterButton onClick={() => setShowFilter(!showFilter)} />
                            </div>
                        )}
                        <div className={filterResponsive}
                            style={{
                                display: windowWidth >= 768 ? 'block' : showFilter ? 'block' : 'none',
                            }}>
                            <CoursesFilter onSubmit={handleFilter} />
                        </div>

                        <div className={rightResponsive}>
                            <div className="row  rtl">
                                {courses.length > 0 ? (
                                    courses.map((item, index) => (
                                        <>
                                            <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12 mb-main"  key={index} style={{ position: "relative" , cursor:'pointer' }}>
                                                <div
                                                    onClick={(e) => {
                                                        if (item?.isOpenedToRegister) {
                                                            if(item?.isCaltureCourse){
                                                                if(isLoggedIn){
                                                                    navigate(`/courseEnrollmentDate?Id=${item?.id}`);
                                                                }else{
                                                                    navigate(`/login?redirectURL=/courseEnrollmentDate?Id=${item?.id}`);
                                                                }
                                                            }else{
                                                                navigate(`/courseEnrollment?Id=${item?.id}`, {
                                                                    state: !item?.isOpenedToRegister ? item?.link : {},
                                                                });
                                                            }
                                                        } else {

                                                            if (!!item?.link && item?.link != '-') {

                                                                navigate(`/courseDetails?Id=${item?.id}&name=${item?.title}`, {
                                                                    state: !item?.isOpenedToRegister ? { link: item?.link } : {},
                                                                });
                                                            } else {

                                                                e.preventDefault();
                                                            }

                                                        }
                                                    }}
                                                    className={whiteCard}
                                                >
                                                    <div className='row h-100'>
                                                        <div style={{ position: 'relative' }}>
                                                            <div className='w-100 position-relative mb-form-group'>
                                                                <div>
                                                                    <img src={item?.image} className="w-100 border-15" alt={item?.title} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <>
                                                            <div className="horseCardTitle mb-1">{showFirst12Words(item?.title)}</div>
                                                            <p className="horseCardDescription fw-bold ">{showFirst22Words(item?.subtitle)}</p>
                                                            <div className="newsPageNewsDateContainer mt-auto">
                                                                <div className="newsPageNewsDay">{item?.dipslayDate[0]}</div>
                                                                <div className="newsPageDateSpacer"></div>
                                                                <div className="newsPageMonthAndYear">
                                                                    <span>{translateMonthToArabic(item?.dipslayDate[1], currentLanguage == 'en' ? 'en-US' : 'ar-AE')}</span>
                                                                    <span>{item?.dipslayDate[2]}</span>
                                                                </div>
                                                            </div>
                                                        </>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ))
                                ) : (
                                    <div className="text-center bold color-eahsred">
                                        {translate('web.nodataFound', 'No News Found with Your Filter Parameters')}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}
